class BannannaNotices extends HTMLElement {
 connectedCallback() {
  if (this.initialized) return; this.initialized = true;
  this.started = Date.now(); this.lastClosed = 0; this.controller = new AbortController(); this.memory = new Map();
  this.active = null; this.userOpened = false;
  this.addEventListener('click', event => {
   const close = event.target.closest('[data-dismiss]');
   const reopen = event.target.closest('[data-reopen]');
   const copy = event.target.closest('[data-copy]');
   if (close) this.dismiss(close.dataset.dismiss);
   if (reopen) this.show(reopen.dataset.reopen, true);
   if (copy) this.copyCode(copy);
  }, { signal: this.controller.signal });
  this.addEventListener('keydown', event => { if (event.key === 'Escape' && this.active && this.querySelector(`[data-${this.active}]`)?.contains(event.target)) this.dismiss(this.active); }, { signal: this.controller.signal });
  this.querySelector('form')?.addEventListener('submit', event => {
   if (!event.target.checkValidity()) return;
   this.store('pending', String(Date.now()));
   event.target.querySelector('[type=submit]').disabled = true;
  }, { signal: this.controller.signal });
  const pending = Number(this.read('pending'));
  if (pending && Date.now() - pending < 600000 && (this.querySelector('[data-newsletter-success]') || this.querySelector('[data-newsletter-error]'))) {
   this.active = 'newsletter';
   if (this.querySelector('[data-newsletter-success]')) { this.store('subscribed','1'); this.store('pending','0'); }
  }
  if (this.querySelector('[data-newsletter-success]') && !this.active) { this.querySelector('[data-newsletter]')?.remove(); this.querySelector('[data-reopen=newsletter]')?.remove(); }
  if (this.dataset.subscribed === 'true') this.store('subscribed','1');
  this.privacyReady = false;
  const loaded = error => { this.privacyReady = !error; };
  if (window.Shopify?.customerPrivacy) loaded();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], loaded);
  this.tick();
 }
 disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
 store(key,value) { this.memory.set(key,value); try { sessionStorage.setItem(`bannanna-notice-${key}`,value); } catch {} }
 read(key) { try { return sessionStorage.getItem(`bannanna-notice-${key}`) || ''; } catch { return this.memory.get(key) || ''; } }
 blocked() {
  if (document.hidden || !this.privacyReady) return true;
  // The footer already offers newsletter and support; keep automatic invitations out of its way.
  const footer = document.querySelector('footer');
  const footerBounds = footer?.getBoundingClientRect();
  if (!this.userOpened && footerBounds?.height > 0 && footerBounds.top < window.innerHeight && footerBounds.bottom > 0) return true;
  if (document.activeElement?.matches('input,textarea,select') && !this.contains(document.activeElement)) return true;
  if (this.privacyBlocked()) return true;
  return !!document.querySelector('theme-drawer[open], dialog[open], header-drawer details[open]');
 }
 privacyBlocked() {
  if (!this.privacyReady) return true;
  const banner = document.querySelector('#shopify-pc__banner');
  if (banner && getComputedStyle(banner).display !== 'none' && banner.getBoundingClientRect().height > 0) return true;
  const preferences = document.querySelector('#shopify-pc__prefs');
  if (preferences && getComputedStyle(preferences).display !== 'none' && preferences.getBoundingClientRect().height > 0) return true;
  if (window.Shopify?.customerPrivacy?.shouldShowBanner?.()) return true;
  return false;
 }
 tick() {
  if (!this.isConnected) return;
  if (this.privacyBlocked()) this.privacyWasBlocked = true;
  else if (this.privacyWasBlocked) { this.started = Date.now(); this.privacyWasBlocked = false; }
  const baseBlocked = this.blocked();
  const nativeForms = [...document.querySelectorAll('shopify-forms-embed')];
  nativeForms.forEach(host => host.classList.toggle('bannanna-forms-paused', baseBlocked));
  const nativeVisible = !baseBlocked && nativeForms.some(host => [...(host.shadowRoot?.querySelectorAll('[role=dialog]') || [])].some(panel => getComputedStyle(panel).display !== 'none' && panel.getBoundingClientRect().height > 0));
  if (this.lastNativeVisible && !nativeVisible) this.lastClosed = Date.now();
  this.lastNativeVisible = nativeVisible;
  if (nativeVisible && this.active) { this.active = null; this.lastClosed = Date.now(); }
  const blocked = baseBlocked || nativeVisible;
  const elapsed = (Date.now() - this.started) / 1000;
  if (!blocked && !this.active && Date.now() - this.lastClosed >= 20000) {
   if (this.querySelector('[data-newsletter]') && !this.read('newsletter') && !this.read('subscribed') && elapsed >= Number(this.dataset.newsletterDelay)) this.show('newsletter');
   else if (this.querySelector('[data-help]') && !this.read('help') && elapsed >= Number(this.dataset.helpDelay)) this.show('help');
  }
  this.querySelectorAll('[data-newsletter], [data-help]').forEach(panel => { panel.hidden = blocked || !panel.hasAttribute(`data-${this.active}`); });
  this.querySelectorAll('[data-reopen]').forEach(button => { const kind = button.dataset.reopen; button.hidden = kind === 'newsletter' || blocked || !!this.active || !this.read(kind); button.setAttribute('aria-expanded',String(this.active === kind)); });
  this.timer = setTimeout(() => this.tick(),1000);
 }
 show(kind,userOpened=false) {
  if (!this.querySelector(`[data-${kind}]`)) return;
  this.active = kind; this.userOpened = userOpened; this.store(kind,'1');
  const panel = this.querySelector(`[data-${kind}]`);
  this.querySelectorAll('[data-newsletter], [data-help]').forEach(item => { item.hidden = item !== panel; });
  this.querySelectorAll('[data-reopen]').forEach(button => { button.hidden = true; button.setAttribute('aria-expanded', String(button.dataset.reopen === kind)); });
  if (userOpened) (panel.querySelector('[data-email]') || panel.querySelector('a'))?.focus();
  this.querySelector('[data-notice-status]').textContent = panel.querySelector('h2').textContent;
 }
 dismiss(kind) {
  const panel = this.querySelector(`[data-${kind}]`); const restore = panel?.contains(document.activeElement);
  panel.hidden = true; this.store(kind,'1'); this.lastClosed = Date.now(); this.active = null;
  const teaser = this.querySelector(`[data-reopen=${kind}]`);
  if (teaser && kind !== 'newsletter') { teaser.setAttribute('aria-expanded','false'); teaser.hidden = false; if (restore) teaser.focus(); }
 }
 async copyCode(button) {
  try { await navigator.clipboard.writeText(button.dataset.copy); button.textContent = button.dataset.copiedLabel; }
  catch { this.querySelector('[data-copy-status]').textContent = this.querySelector('[data-copy-error]').textContent; }
 }
}
if (!customElements.get('bannanna-notices')) customElements.define('bannanna-notices',BannannaNotices);
